import React from "react";

const CloseIcon = (props) => {
	return (
		<svg
			width="44"
			height="44"
			viewBox="0 0 44 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<rect
				x="0.5"
				y="0.5"
				width="43"
				height="43"
				rx="21.5"
				stroke="#A0A3BD"
			/>
			<path
				d="M16 16L28.7742 28.7742"
				stroke="#A0A3BD"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M16 28.7734L28.7742 15.9992"
				stroke="#A0A3BD"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export default CloseIcon;
